(function () {
  // iPadOS lets a long-press lift a product image out of the card into a native
  // drag preview that tilts/rotates while it follows the finger (the "images
  // rotate when grabbed" bug). CSS -webkit-user-drag is unreliable for
  // touch-initiated drags, so cancel the drag at the source: preventing
  // dragstart aborts the native lift. Swiper handles all real touch gestures
  // itself, so no legitimate dragging happens inside these cards.
  document.addEventListener(
    "dragstart",
    function (e) {
      if (e.target && e.target.closest && e.target.closest(".product_card")) {
        e.preventDefault();
      }
    },
    true,
  );

  function initVerticalThumbnailSlider(slider) {
    const list = slider.querySelector(".thumbnail-list");
    const prevOld = slider.querySelector(".slider-button--prev");
    const nextOld = slider.querySelector(".slider-button--next");

    if (!list || !prevOld || !nextOld) return;

    // Clone buttons to strip all existing event listeners (Dawn's bound handlers)
    const prev = prevOld.cloneNode(true);
    const next = nextOld.cloneNode(true);
    prevOld.parentNode.replaceChild(prev, prevOld);
    nextOld.parentNode.replaceChild(next, nextOld);

    // Update Dawn's internal button references so its update() won't crash
    slider.prevButton = prev;
    slider.nextButton = next;

    function getItems() {
      return Array.from(list.querySelectorAll(".thumbnail-list__item"));
    }

    function getClosestIndex(items) {
      let closest = 0;
      let minDiff = Infinity;
      items.forEach((item, i) => {
        const diff = Math.abs(item.offsetTop - list.scrollTop);
        if (diff < minDiff) {
          minDiff = diff;
          closest = i;
        }
      });
      return closest;
    }

    let targetIndex = 0;
    let syncTimer = null;

    // After any scroll settles (thumbnail click, variant change, etc.), re-sync index
    list.addEventListener("scroll", () => {
      clearTimeout(syncTimer);
      syncTimer = setTimeout(() => {
        targetIndex = getClosestIndex(getItems());
      }, 150);
    });

    prev.addEventListener("click", (e) => {
      e.preventDefault();
      const items = getItems();
      targetIndex = Math.max(0, targetIndex - 1);
      list.scrollTo({ top: items[targetIndex].offsetTop, behavior: "smooth" });
    });

    next.addEventListener("click", (e) => {
      e.preventDefault();
      const items = getItems();
      targetIndex = Math.min(items.length - 1, targetIndex + 1);
      list.scrollTo({ top: items[targetIndex].offsetTop, behavior: "smooth" });
    });

    // Keep buttons enabled — Dawn's disabled logic is horizontal-scroll-based
    prev.removeAttribute("disabled");
    next.removeAttribute("disabled");

    const observer = new MutationObserver(() => {
      prev.removeAttribute("disabled");
      next.removeAttribute("disabled");
    });
    observer.observe(prev, { attributes: true, attributeFilter: ["disabled"] });
    observer.observe(next, { attributes: true, attributeFilter: ["disabled"] });
  }

  function attachToAllThumbnailSliders() {
    document
      .querySelectorAll("slider-component.thumbnail-slider")
      .forEach((slider) => {
        if (slider._verticalInit) return;
        slider._verticalInit = true;
        initVerticalThumbnailSlider(slider);
      });
  }

  // Run after SliderComponent custom element is defined and connected
  customElements.whenDefined("slider-component").then(() => {
    // Small delay to ensure connectedCallback has run on all existing elements
    requestAnimationFrame(() => {
      attachToAllThumbnailSliders();
    });

    // Also catch dynamically added sliders (e.g. quick-view)
    const domObserver = new MutationObserver(attachToAllThumbnailSliders);
    domObserver.observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
  });
})();

// Store swiper instances globally with UNIQUE names
window.swiperInstances = {
  bannerSwiper: null,
  productGlow: null,
  productGlowfour: null,
  productGetLook: null,
  productGetLookFour: null,
  realResult: null,
  fiveItems: [],
  testimonials: null,
  brands: null,
  bodiskin: null,
  galleryTop: null,
  galleryThumbs: null,
  skincare: null,
  productSwiper: null,
  headerProduct: null,
  shopBanner: null,
  ingredients: null,
};

// Initialise EVERY .five_items_slider on the page.
//
// The PDP renders more than one: the You×Bodiskin block (main-product.liquid)
// AND the image-carousel section. A single `new Swiper(".five_items_slider")`
// only wires the FIRST match — the other slider stays un-initialised, so it's
// stuck at the CSS FOUC-guard width with its images flashing and no scroll
// ("scroller doesn't work"). Loop over every element instead, and scope each
// slider's nav buttons to itself (a string selector resolves to the first
// slider's arrows for every instance).
//
// Shared with product-variant-metafields.js so a colour-change re-init produces
// identical sliders to first paint. Idempotent: destroys any existing instances
// before rebuilding, so it's safe to call repeatedly.
window.initFiveItemsSliders = function initFiveItemsSliders() {
  window.swiperInstances = window.swiperInstances || {};

  // Tear down any existing instances (colour-change re-runs this).
  const existing = window.swiperInstances.fiveItems;
  if (Array.isArray(existing)) {
    existing.forEach(function (s) {
      if (s && typeof s.destroy === "function") s.destroy(true, true);
    });
  } else if (existing && typeof existing.destroy === "function") {
    existing.destroy(true, true);
  }
  window.swiperInstances.fiveItems = [];

  document.querySelectorAll(".five_items_slider").forEach(function (fiveEl) {
    if (!fiveEl.querySelector(".swiper-slide")) return;

    // Physically reorder slides on mobile by --mobile-order before Swiper init
    // (CSS order breaks Swiper loop clones, so we sort the DOM instead).
    if (window.innerWidth < 768) {
      const fiveWrapper = fiveEl.querySelector(".swiper-wrapper");
      if (fiveWrapper) {
        Array.from(fiveWrapper.querySelectorAll(".swiper-slide"))
          .sort(function (a, b) {
            const aO =
              parseInt(
                getComputedStyle(a).getPropertyValue("--mobile-order").trim(),
              ) || 999;
            const bO =
              parseInt(
                getComputedStyle(b).getPropertyValue("--mobile-order").trim(),
              ) || 999;
            return aO - bO;
          })
          .forEach(function (slide) {
            fiveWrapper.appendChild(slide);
          });
      }
    }

    const instance = new Swiper(fiveEl, {
      loop: true,
      // "2%" of the container (~2vw, full-width section) instead of a px number:
      // a number is frozen in px at init, while a percent string is re-read by
      // Swiper on every resize, so the gap and slides re-scale live without us
      // calling update() on this loop slider (which flickers).
      spaceBetween: "2%",
      slidesPerView: 5,
      observer: true,
      observeParents: true,
      // Ignore arrow taps / swipes fired mid-transition. Without this, hammering
      // the mobile nav stacks slideNext/slidePrev calls onto an in-progress loop
      // transition, and the loopFix repositioning leaves the track stuck between
      // slides until you swipe manually. This advances one slide per burst instead.
      preventInteractionOnTransition: true,
      // Scope nav to THIS slider's own buttons — a string selector would resolve
      // to the first slider's arrows for every instance.
      navigation: {
        nextEl: fiveEl.querySelector(".swiper-button-next"),
        prevEl: fiveEl.querySelector(".swiper-button-prev"),
      },
      breakpoints: {
        768: { slidesPerView: 5 },
        0: { slidesPerView: 2, spaceBetween: 20 },
      },
      on: {
        init: function () {
          const swiper = this;
          requestAnimationFrame(function () {
            swiper.update();
          });
        },
      },
    });
    window.swiperInstances.fiveItems.push(instance);
  });

  if (document.readyState !== "complete") {
    window.addEventListener(
      "load",
      function () {
        (window.swiperInstances.fiveItems || []).forEach(function (s) {
          if (s && typeof s.update === "function") s.update();
        });
      },
      { once: true },
    );
  }
};

// Helper function to convert viewport width to pixels
function vw(v) {
  return window.innerWidth * (v / 100);
}

// Complete destroy function
function destroySwiper(swiperInstance) {
  if (swiperInstance) {
    try {
      swiperInstance.destroy(true, true);
    } catch (e) {
      console.log("Destroy error:", e);
    }
  }
}

// Dynamic breakpoints for Glow Wear slider
const dynamicBreakpoints = {
  768: {
    slidesPerView: 2.5,
    spaceBetween: vw(1.5),
    loop: true,
    get slidesOffsetBefore() {
      return vw(30);
    },
    get slidesOffsetAfter() {
      return vw(0);
    },
  },
  0: {
    slidesPerView: 1.2,
    spaceBetween: 20,
    centeredSlides: false,
    navigation: { enabled: false },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    get slidesOffsetBefore() {
      return vw(0);
    },
    get slidesOffsetAfter() {
      return vw(0);
    },
  },
};

function generateBreakpointValues() {
  const bp = {};
  for (let key in dynamicBreakpoints) {
    const obj = dynamicBreakpoints[key];
    bp[key] = {};
    for (let prop in obj) {
      const descriptor = Object.getOwnPropertyDescriptor(obj, prop);
      if (descriptor && descriptor.get) {
        bp[key][prop] = obj[prop];
      } else {
        bp[key][prop] = obj[prop];
      }
    }
  }
  return bp;
}

// Get The Look breakpoints
const getLookBreakpoints = {
  1700: {
    slidesPerView: 2.5,
    spaceBetween: vw(1.5),

    get slidesOffsetBefore() {
      return vw(30);
    },
    get slidesOffsetAfter() {
      return vw(0);
    },
  },
  993: {
    slidesPerView: 2.5,
    spaceBetween: vw(1.5),
    get slidesOffsetBefore() {
      return vw(30);
    },
    get slidesOffsetAfter() {
      return vw(0);
    },
  },
  768: {
    slidesPerView: 1.5,
    spaceBetween: vw(1.5),
    get slidesOffsetBefore() {
      return vw(12);
    },
    get slidesOffsetAfter() {
      return vw(12);
    },
  },
  0: {
    slidesPerView: 1.2,
    spaceBetween: 10,
    centeredSlides: false,
    navigation: { enabled: false },
    pagination: {
      el: ".get-the-look-slider .swiper-pagination",
      clickable: true,
    },
    get slidesOffsetBefore() {
      return vw(0);
    },
    get slidesOffsetAfter() {
      return vw(0);
    },
  },
};

function generateGetLookBreakpoints() {
  const bp = {};
  for (let key in getLookBreakpoints) {
    const obj = getLookBreakpoints[key];
    bp[key] = {};
    for (let prop in obj) {
      const descriptor = Object.getOwnPropertyDescriptor(obj, prop);
      bp[key][prop] = descriptor && descriptor.get ? obj[prop] : obj[prop];
    }
  }
  return bp;
}

// Initialize all swipers
function initAllSwipers() {
  // Destroy existing instances first.
  // Skip cartUpsell — the <cart-product-slider> custom element owns its own
  // lifecycle (init on connect, destroy on disconnect). initAllSwipers never
  // re-creates it, so tearing it down here on resize/orientationchange/bfcache
  // left a dead slider whose arrows and swipe stopped working (mobile).
  Object.keys(window.swiperInstances).forEach((key) => {
    if (key === "cartUpsell") return;
    destroySwiper(window.swiperInstances[key]);
    window.swiperInstances[key] = null;
  });

  // Also check DOM for any existing swiper instances
  // Skip tabImageSwiper and the cart upsell slider — they manage their own state
  // and must not be reset by initAllSwipers
  document.querySelectorAll(".swiper").forEach((el) => {
    if (el.classList.contains("tabImageSwiper")) return;
    if (el.classList.contains("cart-product-swiper")) return;
    if (el.swiper) {
      el.swiper.destroy(true, true);
    }
  });

  // Small delay to ensure clean state
  setTimeout(() => {
    // 0. BANNER SWIPER (Home Banner Section)
    if ($("#bannerSwiper").length) {
      const bannerEl = document.getElementById("bannerSwiper");
      const isMobileEnabled = bannerEl.classList.contains(
        "mobile-swiper-enabled",
      );
      const isDesktopEnabled = bannerEl.classList.contains(
        "desktop-swiper-enabled",
      );

      // Determine if we're on mobile
      const isMobile = window.innerWidth <= 767;
      const shouldInitializeSlider =
        (isMobile && isMobileEnabled) || (!isMobile && isDesktopEnabled);

      if (shouldInitializeSlider) {
        window.swiperInstances.bannerSwiper = new Swiper("#bannerSwiper", {
          loop: true,
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
          },
          autoplay: {
            delay: 5000,
            disableOnInteraction: false,
          },
          observer: true,
          observeParents: true,
        });
      }
    }

    // 1. BRANDS SWIPER
    if ($(".brandsSwiper").length) {
      let brandConfig = {
        slidesPerView: 6,
        spaceBetween: vw(2),
        loop: true,
        speed: 4000,
        allowTouchMove: false,
        observer: true,
        observeParents: true,
        breakpoints: {
          1024: { slidesPerView: 6, allowTouchMove: false },
          768: { slidesPerView: 4, allowTouchMove: false },
          480: { slidesPerView: 3, allowTouchMove: true },
          0: { slidesPerView: 3, allowTouchMove: true },
        },
      };

      if (window.innerWidth < 768) {
        brandConfig.autoplay = {
          delay: 0,
          disableOnInteraction: false,
        };
      }

      window.swiperInstances.brands = new Swiper(".brandsSwiper", brandConfig);
    }

    // 2. SHOP BANNER SWIPER
    if ($(".shop-banner-swipper").length) {
      window.swiperInstances.shopBanner = new Swiper(".shop-banner-swipper", {
        slidesPerView: 1,
        loop: true,
        effect: "fade",
        fadeEffect: { crossFade: true },
        speed: 1000,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        observer: true,
        observeParents: true,
      });
    }

    // 3. GLOW WEAR SLIDER
    if (
      $(".related--more-than-four:not(.glow-wear-peek) .product_swiper").length
    ) {
      window.swiperInstances.productGlow = new Swiper(
        ".related--more-than-four:not(.glow-wear-peek) .product_swiper",
        {
          slidesPerView: 2.5,
          spaceBetween: 30,
          centeredSlides: false,
          loop: true,
          grabCursor: true,
          observer: true,
          observeParents: true,
          navigation: {
            nextEl:
              ".related--more-than-four:not(.glow-wear-peek) .swiper-button-next",
            prevEl:
              ".related--more-than-four:not(.glow-wear-peek) .swiper-button-prev",
          },
          pagination: {
            el: ".related--more-than-four:not(.glow-wear-peek) .swiper-pagination",
            clickable: true,
          },
          on: {
            slideChange() {
              this.pagination.update();
            },
          },
          breakpoints: generateBreakpointValues(),
        },
      );
    }

    // 3b. GLOW WEAR SLIDER — homepage/about peek look (keeps loop).
    // Dedicated instance so the PDP "shop it with" slider (which also carries
    // .glow-wear-slider) is untouched. The peek is produced purely in CSS
    // (.glow-wear-peek track is widened + shifted left); slidesPerView 3.64 is
    // tuned to that widen so card size matches the design.
    if ($(".glow-wear-peek .product_swiper").length) {
      // .gw-on-index is set by the section on the home page: the CSS peek
      // shift (117.68% widen) is disabled there, so slidesPerView drops to
      // 3.64 / 1.1768 ≈ 3.09 to keep the card size unchanged.
      const glowWearOnIndex = $(".glow-wear-peek").hasClass("gw-on-index");
      window.swiperInstances.glowWearPeek = new Swiper(
        ".glow-wear-peek .product_swiper",
        {
          slidesPerView: 1.2,
          spaceBetween: 20,
          centeredSlides: false,
          loop: true,
          grabCursor: true,
          observer: true,
          observeParents: true,
          navigation: {
            nextEl: ".glow-wear-peek .swiper-button-next",
            prevEl: ".glow-wear-peek .swiper-button-prev",
          },
          pagination: {
            el: ".glow-wear-peek .swiper-pagination",
            clickable: true,
          },
          on: {
            slideChange() {
              this.pagination.update();
            },
          },
          breakpoints: {
            768: {
              slidesPerView: glowWearOnIndex ? 3.09 : 3.64,
              spaceBetween: vw(2.1),
              slidesOffsetBefore: 0,
              slidesOffsetAfter: 0,
            },
            0: {
              slidesPerView: 1.2,
              spaceBetween: 38,
              centeredSlides: false,
              navigation: { enabled: false },
              pagination: {
                el: ".glow-wear-peek .swiper-pagination",
                clickable: true,
              },
            },
          },
        },
      );
    }

    // GET THE LOOK SLIDER (FOUR OR LESS)
    if (
      $(".related--four-or-less:not(.glow-wear-peek) .product_swiper").length
    ) {
      window.swiperInstances = window.swiperInstances || {};

      window.swiperInstances.productGlowFour = new Swiper(
        ".related--four-or-less:not(.glow-wear-peek) .product_swiper",
        {
          slidesPerView: 4,
          spaceBetween: 30,
          centeredSlides: false,
          loop: false,
          grabCursor: true,
          observer: true,
          observeParents: true,
          navigation: false,
          pagination: {
            el: ".related--four-or-less .swiper-pagination",
            clickable: true,
          },

          breakpoints: {
            768: {
              slidesPerView: 4,
              spaceBetween: vw(1.5),
              slidesOffsetBefore: 0,
              slidesOffsetAfter: 0,
            },

            0: {
              slidesPerView: 1.2,
              spaceBetween: 10,
              centeredSlides: false,
              navigation: false,
              pagination: {
                el: ".related--four-or-less .swiper-pagination",
                clickable: true,
              },
              slidesOffsetBefore: 0,
              slidesOffsetAfter: 0,
            },
          },
        },
      );
    }

    // 4. GET THE LOOK SLIDER (NOT FOUR)
    if ($(".get-the-look-slider-not-four .img_slider").length) {
      // .gtl-on-index is set by the section when rendered on the home page
      const getLookOnIndex = $(".get-the-look-slider-not-four").hasClass(
        "gtl-on-index",
      );
      window.swiperInstances.productGetLook = new Swiper(
        ".get-the-look-slider-not-four .img_slider",
        {
          slidesPerView: 2.5,
          spaceBetween: 30,
          centeredSlides: !getLookOnIndex,
          loop: true,
          grabCursor: true,
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0,
          observer: true,
          observeParents: true,
          navigation: {
            nextEl: ".get-the-look-slider-not-four .swiper-button-next",
            prevEl: ".get-the-look-slider-not-four .swiper-button-prev",
          },
          pagination: {
            el: ".get-the-look-slider-not-four .swiper-pagination",
            clickable: true,
          },
          breakpoints: generateGetLookBreakpoints(),
        },
      );
    }

    // 5. GET THE LOOK SLIDER (FOUR SLIDES)
    if ($(".get-the-look-slider-four .img_slider").length) {
      window.swiperInstances.productGetLookFour = new Swiper(
        ".get-the-look-slider-four .img_slider",
        {
          slidesPerView: 4,
          spaceBetween: 20,
          centeredSlides: false,
          loop: false,
          grabCursor: true,
          observer: true,
          observeParents: true,
          navigation: {
            nextEl: ".get-the-look-slider-four .swiper-button-next",
            prevEl: ".get-the-look-slider-four .swiper-button-prev",
          },
          pagination: {
            el: ".get-the-look-slider-four .swiper-pagination",
            clickable: true,
          },
          breakpoints: {
            0: {
              slidesPerView: 1.2,
              spaceBetween: 10,
              centeredSlides: false,
              navigation: { enabled: false },
              pagination: {
                el: ".get-the-look-slider-four .swiper-pagination",
                clickable: true,
              },
              get slidesOffsetBefore() {
                return vw(0);
              },
              get slidesOffsetAfter() {
                return vw(0);
              },
            },
            768: {
              slidesPerView: 4,
              spaceBetween: vw(1.5),
              centeredSlides: false,
              get slidesOffsetBefore() {
                return 0;
              },
              get slidesOffsetAfter() {
                return 0;
              },
            },
          },
        },
      );
    }

    // 6. REAL RESULT SWIPER
    if ($(".real_result").length) {
      window.swiperInstances.realResult = new Swiper(".real_result", {
        slidesPerView: 1,
        loop: true,
        spaceBetween: 30,
        allowTouchMove: false,
        observer: true,
        observeParents: true,
      });
    }

    // 7. BODISKIN SWIPER
    if ($(".bodiskin-swiper").length) {
      window.swiperInstances.bodiskin = new Swiper(".bodiskin-swiper", {
        slidesPerView: 1,
        spaceBetween: vw(2),
        // Match the PDP "how to wear" (.productSwiper) feel: an 800ms glide
        // instead of Swiper's snappy 300ms default (the "super fast"), and no
        // loop — looping 3 single slides forced a loopFix reposition at the
        // wrap point, which is what produced the wobble. Desktop shows all 3 as
        // a static row, so this only affects the mobile single-slide scroll.
        speed: 800,
        loop: false,
        pagination: {
          el: ".bodiskin-pagination1",
          clickable: true,
          renderBullet: function (index, className) {
            let number = (index + 1).toString().padStart(2, "0");
            return '<span class="' + className + '">' + number + "</span>";
          },
        },
        navigation: {
          nextEl: ".bodiskin-nav-btn--next",
          prevEl: ".bodiskin-nav-btn--prev",
        },
        breakpoints: {
          0: { slidesPerView: 1, spaceBetween: 0 },
          768: { slidesPerView: 3, spaceBetween: vw(2) },
        },
      });

      // iOS freeze guard: rapidly tapping the numbered pagination interrupts the
      // slide transition. On iOS WebKit an interrupted transition often never
      // fires `transitionend`, so Swiper's `animating` flag stays true and all
      // navigation locks up. Block pagination taps for the duration of each
      // transition (so it can't be interrupted), with a safety timeout that
      // re-arms even if `transitionend` is dropped.
      (function () {
        var sw = window.swiperInstances.bodiskin;
        var pag = document.querySelector(".bodiskin-pagination1");
        var reArm;
        sw.on("transitionStart", function () {
          if (pag) pag.style.pointerEvents = "none";
          clearTimeout(reArm);
          reArm = setTimeout(
            function () {
              if (pag) pag.style.pointerEvents = "";
              sw.animating = false; // failsafe: transitionend was dropped
            },
            (sw.params.speed || 300) + 150,
          );
        });
        sw.on("transitionEnd", function () {
          clearTimeout(reArm);
          if (pag) pag.style.pointerEvents = "";
        });
      })();
    }

    // if (document.querySelector(".gallery-thumbs")) {

    //   const thumbsEl = document.querySelector(".gallery-thumbs");
    //   const slides = thumbsEl.querySelectorAll(".swiper-slide");
    //   const totalSlides = slides.length;

    //   const isSmallSet = totalSlides < 5;

    //   window.swiperInstances = window.swiperInstances || {};

    //   window.swiperInstances.galleryThumbs = new Swiper(".gallery-thumbs", {
    //     direction: "vertical",
    //     loop: !isSmallSet,
    //     slidesPerView: isSmallSet ? "auto" : 4.5,
    //     spaceBetween: 10,
    //     watchSlidesProgress: true,
    //     watchSlidesVisibility: true,
    //     freeMode: false,

    //     navigation: !isSmallSet ? {
    //       nextEl: ".thumb-button-next",
    //       prevEl: ".thumb-button-prev",
    //     } : false,

    //     on: {
    //       init: function () {
    //         if (isSmallSet) {
    //           this.slides.forEach(slide => {
    //             slide.style.height = "10vw";
    //           });
    //         }
    //       }
    //     }
    //   });

    //   // Hide arrows completely if less than 5 slides
    //   if (isSmallSet) {
    //     document.querySelector(".thumb-button-next")?.classList.add("d-none");
    //     document.querySelector(".thumb-button-prev")?.classList.add("d-none");
    //   }
    // }

    // if (document.querySelector(".gallery-thumbs")) {

    //   const thumbsEl = document.querySelector(".gallery-thumbs");
    //   const slides = thumbsEl.querySelectorAll(".swiper-slide");
    //   const totalSlides = slides.length;

    //   const isSmallSet = totalSlides < 5;

    //   window.swiperInstances = window.swiperInstances || {};

    //   window.swiperInstances.galleryThumbs = new Swiper(".gallery-thumbs", {
    //     direction: "vertical",
    //     loop: !isSmallSet,
    //     slidesPerView: isSmallSet ? "auto" : 4.5,
    //     spaceBetween: 10,

    //     watchSlidesProgress: true,
    //     watchSlidesVisibility: true,

    //     centeredSlides: !isSmallSet,
    //     centeredSlidesBounds: !isSmallSet,   // ⭐ important for initial render
    //     slideToClickedSlide: true,

    //     freeMode: false,

    //     navigation: !isSmallSet ? {
    //       nextEl: ".thumb-button-next",
    //       prevEl: ".thumb-button-prev",
    //     } : false,

    //     on: {
    //       init: function () {
    //         if (isSmallSet) {
    //           this.slides.forEach(slide => {
    //             slide.style.height = "10vw";
    //           });
    //         }

    //         // ⭐ force correct centering on first load
    //         if (!isSmallSet) {
    //           this.update();
    //           this.slideToLoop(0, 0, false);
    //         }
    //       }
    //     }
    //   });

    //   // Hide arrows completely if less than 5 slides
    //   if (isSmallSet) {
    //     document.querySelector(".thumb-button-next")?.classList.add("d-none");
    //     document.querySelector(".thumb-button-prev")?.classList.add("d-none");
    //   }
    // }

    if (document.querySelector(".gallery-thumbs")) {
      const thumbsEl = document.querySelector(".gallery-thumbs");
      const slides = thumbsEl.querySelectorAll(".swiper-slide");
      const totalSlides = slides.length;

      const isSmallSet = totalSlides < 5;

      window.swiperInstances = window.swiperInstances || {};

      window.swiperInstances.galleryThumbs = new Swiper(".gallery-thumbs", {
        direction: "vertical",
        loop: !isSmallSet,

        // ⭐ KEY CHANGE
        slidesPerView: isSmallSet ? "auto" : 5,

        spaceBetween: 10,

        watchSlidesProgress: true,
        watchSlidesVisibility: true,

        // ⭐ REQUIRED
        centeredSlides: !isSmallSet,
        centeredSlidesBounds: !isSmallSet,

        slideToClickedSlide: true,
        freeMode: false,

        navigation: !isSmallSet
          ? {
              nextEl: ".thumb-button-next",
              prevEl: ".thumb-button-prev",
            }
          : false,

        on: {
          init: function () {
            if (isSmallSet) {
              this.slides.forEach((slide) => {
                slide.style.height = "10vw";
              });
            }

            if (!isSmallSet) {
              this.update();
              this.slideToLoop(0, 0, false);
            }
          },
        },
      });

      // Hide arrows completely if less than 5 slides
      if (isSmallSet) {
        document.querySelector(".thumb-button-next")?.classList.add("d-none");
        document.querySelector(".thumb-button-prev")?.classList.add("d-none");
      }
    }

    // Initialize galleryTop SECOND and link thumbs
    if (document.querySelector(".gallery-top")) {
      window.swiperInstances.galleryTop = new Swiper(".gallery-top", {
        slidesPerView: 1,
        loop: true,
        spaceBetween: vw(2),
        navigation: {
          nextEl: ".thumb-button-next",
          prevEl: ".thumb-button-prev",
        },
        pagination: {
          el: ".gallery-top-pagination",
          clickable: true,
        },
        thumbs: {
          swiper: window.swiperInstances.galleryThumbs,
        },
        breakpoints: {
          0: { slidesPerView: 1.2, spaceBetween: vw(3) },
          768: { slidesPerView: 1, spaceBetween: vw(2) },
        },
      });
    }

    // 10. SKINCARE SWIPER
    if ($(".skincare-swiper").length) {
      window.swiperInstances.skincare = new Swiper(".skincare-swiper", {
        slidesPerView: 1.5,
        spaceBetween: vw(2),
        loop: true,
        navigation: {
          nextEl: ".skincare-nav__btn--next",
          prevEl: ".skincare-nav__btn--prev",
        },
        breakpoints: {
          0: { slidesPerView: 2, spaceBetween: vw(2) },
          768: { slidesPerView: 4, spaceBetween: vw(2) },
        },
      });
    }

    // if ($(".cart-product-swiper").length) {
    //   window.swiperInstances.skincare = new Swiper(".cart-product-swiper", {
    //     slidesPerView: 1,
    //     spaceBetween: 0,
    //     navigation: {
    //       nextEl: ".cart-product-swiper .swiper-button-next",
    //       prevEl: ".cart-product-swiper .swiper-button-prev",
    //     },
    //   });
    // }

    // 11. PRODUCT SWIPER WITH CUSTOM PAGINATION
    if ($(".productSwiper").length) {
      window.swiperInstances.productSwiper = new Swiper(".productSwiper", {
        direction: "horizontal",
        loop: false,
        speed: 800,
        effect: "fade",
        fadeEffect: { crossFade: true },
        allowTouchMove: false,
        navigation: {
          enabled: false,
        },
        keyboard: { enabled: true },
        mousewheel: { enabled: false },
        on: {
          slideChange: function () {
            updateProductPagination(this.activeIndex);
          },
          init: function () {
            updateProductPagination(this.activeIndex);
          },
        },
      });

      // Custom pagination click handler
      $(".pagination-bullet").on("click", function () {
        const slideIndex = parseInt($(this).attr("data-slide"));
        window.swiperInstances.productSwiper.slideTo(slideIndex);
      });

      function updateProductPagination(activeIndex) {
        $(".pagination-bullet").removeClass("active");
        $(`.pagination-bullet[data-slide="${activeIndex}"]`).addClass("active");
      }
    }

    // 12. HEADER PRODUCT SWIPER
    if ($(".header_product_swiper").length) {
      window.swiperInstances.headerProduct = new Swiper(
        ".header_product_swiper",
        {
          slidesPerView: 1,
          spaceBetween: 0,
          speed: 300,
          // Crossfade instead of sliding left/right: the current cards are
          // seamlessly replaced by the next set with a quick blink.
          effect: "fade",
          fadeEffect: { crossFade: true },
          allowTouchMove: false,
          observer: true,
          observeParents: true,
        },
      );

      // Handle thumbnail hover
      $(document).on("mouseenter", ".slide-thumb", function () {
        let index = Number($(this).data("slide")) - 1;
        if (window.swiperInstances.headerProduct && !isNaN(index)) {
          window.swiperInstances.headerProduct.slideTo(index);
        }
      });
    }

    // 13. FIVE ITEMS SLIDER
    window.initFiveItemsSliders();

    // 14. TESTIMONIALS SLIDER
    if ($(".testemonials_slider").length) {
      window.swiperInstances.testimonials = new Swiper(".testemonials_slider", {
        loop: true,
        spaceBetween: vw(2),
        slidesPerView: 4,
        observer: true,
        observeParents: true,
        navigation: {
          nextEl: ".custom_next_swiper",
          prevEl: ".custom_prev_swiper",
        },
        breakpoints: {
          768: { slidesPerView: 4 },
          0: { slidesPerView: 1.6, spaceBetween: 20 },
        },
      });
    }

    if ($(".ingredients-swiper").length) {
      window.swiperInstances.ingredients = new Swiper(".ingredients-swiper", {
        slidesPerView: 4.5,
        spaceBetween: 30,
        centeredSlides: false, // IMPORTANT
        loop: false, // IMPORTANT
        grabCursor: true,

        navigation: {
          nextEl: ".ingredients-button-next",
          prevEl: ".ingredients-button-prev",
        },

        breakpoints: {
          0: {
            slidesPerView: 2.3,
            spaceBetween: vw(1.8),
          },
          768: {
            slidesPerView: 4.5,
            spaceBetween: vw(1.7),
          },
        },
      });
    }

    // IMAGE CARD GRID SLIDER (mobile always; desktop when opted in via data attr)
    if (document.querySelector(".image-card-grid-swiper")) {
      document
        .querySelectorAll(".image-card-grid-swiper")
        .forEach(function (el, i) {
          var config = {
            slidesPerView: "auto",
            spaceBetween: 12,
            grabCursor: true,
            observer: true,
            observeParents: true,
          };
          // Desktop slider: 3 cards per view from 768px up
          if (el.dataset.desktopSlider === "true") {
            config.breakpoints = {
              768: {
                slidesPerView: 3,
                spaceBetween: 34,
              },
            };
          }
          window.swiperInstances["imageCardGrid" + i] = new Swiper(el, config);
        });
    }

    console.log("All swipers initialized");
    window.dispatchEvent(new CustomEvent("swipersInitialized"));
    window.swipersInitialized = true;
  }, 100);
}

// jQuery Document Ready - ALL YOUR OTHER CODE
$(document).ready(function () {
  // Initialize all swipers
  initAllSwipers();

  // Search icon mobile
  $(".search-icon-mobile").on("click", function () {
    var searchIcon = this;

    function openSearch() {
      $(".search-icon-wrapper details").attr("open", true);
      $(searchIcon).addClass("active");
    }

    openSearch();
  });

  // Close search modal
  $(".search-icon-wrapper .search-modal__close-button").on(
    "click",
    function () {
      $(".search-icon-wrapper .search-icon-mobile").removeClass("active");
    },
  );

  // Open menu
  $(".button-toggle").click(function () {
    $(".mfull-page").addClass("active");
    // Warm the collection tabs (New Arrivals / Bestsellers / Mix) as soon as
    // the menu opens: their HTML is fetched and, since the fetched cards use
    // eager images, the tile images download in the background while the user
    // is still on Featured. Tapping a tab is then instant. loadMfullPanel is
    // idempotent, so re-opening the menu costs nothing.
    document
      .querySelectorAll(".mfull-panel[data-collection-url]")
      .forEach(function (panel) {
        loadMfullPanel(panel);
      });
  });

  // Close menu
  $(".primary_header-mobile .button-toggle").click(function () {
    $(".mfull-page").removeClass("active");
  });

  // Mobile menu tabs
  // In collection mode the Featured tab is server-rendered; the other tabs carry
  // a data-collection-url and fetch their product cards (an alternate collection
  // template rendered with `layout none`) the first time they're opened. We keep
  // the previous tab visible until that fetch lands, so the panel never flashes
  // empty. Returns a promise that resolves once the panel is ready to show.
  function loadMfullPanel(panel) {
    if (!panel) return Promise.resolve();
    var url = panel.getAttribute("data-collection-url");
    if (!url || panel.dataset.mfullLoaded === "true") {
      return Promise.resolve();
    }
    // Reuse the in-flight request if the same tab is tapped again while loading.
    if (panel._mfullPromise) return panel._mfullPromise;

    panel.dataset.mfullLoading = "true";
    panel._mfullPromise = fetch(url)
      .then(function (res) {
        return res.ok ? res.text() : Promise.reject(res.status);
      })
      .then(function (html) {
        var shopBtn = panel.querySelector(".mfull-shop-btn");
        if (shopBtn) {
          shopBtn.insertAdjacentHTML("beforebegin", html);
        } else {
          panel.insertAdjacentHTML("beforeend", html);
        }
        panel.dataset.mfullLoaded = "true";
        delete panel.dataset.mfullLoading;
      })
      .catch(function () {
        // Allow a retry on the next tap; show the (empty) tab so the user isn't stuck.
        delete panel.dataset.mfullLoading;
        delete panel._mfullPromise;
      });
    return panel._mfullPromise;
  }

  // Tracks the most recent tab request so a slow fetch can't swap in after the
  // user has already moved on to another tab.
  var mfullRequestId = 0;

  function switchMfullTab(btn, panel) {
    $(".mfull-tab-btn").removeClass("active");
    $(btn).addClass("active");
    $(".mfull-panel").removeClass("active");
    $(panel).addClass("active");
  }

  $(".mfull-tab-btn").click(function () {
    var btn = this;
    var panel = document.querySelector($(btn).data("target"));
    if (!panel) return;

    var reqId = ++mfullRequestId;
    var needsLoad =
      panel.getAttribute("data-collection-url") &&
      panel.dataset.mfullLoaded !== "true";

    if (!needsLoad) {
      switchMfullTab(btn, panel);
      return;
    }

    // Collection tab not loaded yet: stay on the current tab, flag the tapped
    // button as loading, and only switch once its cards are in the DOM.
    $(btn).addClass("is-loading");
    loadMfullPanel(panel).then(function () {
      $(btn).removeClass("is-loading");
      if (reqId === mfullRequestId) {
        switchMfullTab(btn, panel);
      }
    });
  });

  // Fixed header on scroll
  var lastScroll = 0;
  // While we run a programmatic in-page scroll (e.g. a "Read more" anchor jump)
  // we lock this handler so the header doesn't run through its hide/reveal
  // animation mid-glide — that churn was the "weird movement" on redirect.
  var headerScrollLock = false;

  // Aggressive up/down flicks (trackpad inertia, momentum bounce) reverse the
  // scroll direction by a few px many times a second. Flipping the header
  // state on every 1px reversal restarts its slide transitions mid-flight and
  // can leave it hovering mid-viewport. Require a little real travel in the
  // NEW direction before the state flips; travel that continues the current
  // direction still applies instantly.
  var DIRECTION_HYSTERESIS = 24;
  var downTravel = 0;
  var upTravel = 0;

  function resyncHeaderScroll() {
    lastScroll = window.scrollY || $(window).scrollTop();
    downTravel = 0;
    upTravel = 0;
  }

  // Scroll distance at which the header un-sticks and returns to its neutral top
  // state. Above 920px this mirrors the CSS sticky offset used on the product
  // template: calc(var(--announcement-height) + 1.7vw) + 10px of header padding.
  // At or below 920px we keep the original flat 100px.
  const isDesktop = window.innerWidth > 920;
  function getHeaderResetThreshold() {
    if (!isDesktop) return 100;
    var announcement =
      parseFloat(
        getComputedStyle(document.documentElement).getPropertyValue(
          "--announcement-height",
        ),
      ) || 0;
    return announcement - 10;
  }

  function updateHeaderOnScroll() {
    if (headerScrollLock) return;

    var scroll = window.scrollY || $(window).scrollTop();
    var $header = $("header");

    // iOS rubber-band overshoot reports positions past the real scroll range;
    // acting on the overshoot (and its snap-back) fakes direction changes at
    // the page extremes.
    var maxScroll = document.documentElement.scrollHeight - window.innerHeight;
    if (scroll < 0 || scroll > maxScroll) return;

    if (scroll <= getHeaderResetThreshold()) {
      if (window.location.href.includes("/products/") && isDesktop) {
        $header
          .addClass("header-product")
          .removeClass("header__hidden header__sticky sticky header__animate");
      } else {
        $header.removeClass(
          "header__hidden header__sticky sticky header__animate",
        );
      }
      lastScroll = scroll;
      downTravel = 0;
      upTravel = 0;
      return;
    }

    if (scroll > lastScroll) {
      downTravel += scroll - lastScroll;
      upTravel = 0;
    } else if (scroll < lastScroll) {
      upTravel += lastScroll - scroll;
      downTravel = 0;
    }
    lastScroll = scroll;

    if (downTravel >= DIRECTION_HYSTERESIS) {
      // Scrolling down -> hide. Animate the slide-up ONLY when the header is
      // currently revealed (`sticky`, pinned at top:0 and visible) so it glides
      // away from where it actually is. On the first scroll down from the top
      // the header is still in normal flow, so we hide it instantly — animating
      // from there pops it back to top:0 and flashes it on screen.
      //
      // Only ever ADD the modifier here, never strip it: continued downward
      // scroll re-enters this branch every frame, and removing it mid-slide
      // would cut the 0.7s animation short and snap the header away. It's
      // cleared on reveal (scroll up) and back at the top.
      if ($header.hasClass("sticky")) {
        $header.addClass("header__animate");
      }
      if (
        window.location.href.includes("/products/") &&
        isDesktop &&
        scroll < 150
      ) {
        $header
          .addClass("sticky header-product")
          .removeClass("header__hidden header__sticky");
      } else {
        $header
          .removeClass("sticky header-product")
          .addClass("header__hidden header__sticky");
      }
    } else if (upTravel >= DIRECTION_HYSTERESIS) {
      $header
        .removeClass("header__hidden header__sticky header__animate")
        .addClass("sticky");
    }
  }

  $(window).on("scroll", updateHeaderOnScroll);

  // Page scripts that move the page programmatically (e.g. the Ingredients
  // FAQ accordions on the skinwear library page counter-scroll to keep the
  // tapped question pinned while the previous answer collapses) dispatch
  // these events so their upward corrections aren't read as a real scroll-up
  // that reveals the header. Unlock resyncs the baseline so the next genuine
  // scroll compares against where the page actually ended up.
  document.addEventListener("header:lock", function () {
    headerScrollLock = true;
  });
  document.addEventListener("header:unlock", function () {
    headerScrollLock = false;
    resyncHeaderScroll();
  });

  // Clean in-page anchor navigation (e.g. hero "Read More" -> a section).
  // Glides to the target leaving whitespace above its card so the view lands
  // clean, and holds the header still during the glide instead of letting it
  // hide/reveal. Scoped to real page sections so it never hijacks form
  // skip-links, login/recover :target toggles or Bootstrap accordions/tabs.
  document.addEventListener("click", function (e) {
    var link = e.target.closest('a[href^="#"]');
    if (!link) return;
    if (link.href.includes("#impact")) return;
    if (link.href.includes("#why-we-started")) return;
    var hash = link.getAttribute("href");
    if (!hash || hash === "#") return;

    // Leave interactive toggles to their own native/script behaviour.
    if (link.matches("[data-bs-toggle],[data-bs-target],[data-toggle]")) return;

    var target;
    try {
      target = document.querySelector(hash);
    } catch (err) {
      return; // not a valid selector
    }
    if (!target) return;
    // Only glide to actual page sections.
    if (!target.matches("section, .shopify-section, [data-scroll-section]")) {
      return;
    }

    e.preventDefault();

    // Clear the (revealed) header height + a little breathing room so the
    // section's top whitespace stays visible above its grey card.
    var headerHeight =
      parseFloat(
        getComputedStyle(document.documentElement).getPropertyValue(
          "--header-height",
        ),
      ) || 0;
    // Grey-card sections (size guide, policies) want that breathing-room gap
    // above the card. The FAQ has no card, and the header is un-stickied for
    // this glide, so the same gap just exposes the section ABOVE the FAQ. On
    // mobile, pin the FAQ title to the very top instead (no gap, no bleed).
    var pinToTop =
      (target.id === "faqs" || target.classList.contains("faq_section")) &&
      window.matchMedia("(max-width: 767px)").matches;
    var offset = pinToTop ? 0 : headerHeight + 32;
    var top = target.getBoundingClientRect().top + window.scrollY - offset;
    if (top < 0) top = 0;

    // Hold the header still and reset it to its neutral top state, then glide.
    headerScrollLock = true;
    $("header").removeClass("header__hidden header__sticky sticky");
    window.scrollTo({ top: top, behavior: "smooth" });

    if (history.pushState) history.pushState(null, "", hash);

    var release = function () {
      headerScrollLock = false;
      resyncHeaderScroll(); // so the next real scroll compares cleanly
    };

    if ("onscrollend" in window) {
      window.addEventListener("scrollend", release, { once: true });
      setTimeout(release, 1200); // safety net if scrollend never fires
    } else {
      setTimeout(release, 900);
    }
  });

  // Mega menu
  $(".js_mega_menu, .megamenu").hover(
    function () {
      $(".megamenu").stop().slideDown();
      $(".js_mega_menu").addClass("mega-open");
    },
    function () {
      $(".megamenu").stop().slideUp();
      $(".js_mega_menu").removeClass("mega-open");
    },
  );

  // Real result slide click handler
  $(document).on("click", ".slide-sxt", function () {
    $(this).toggleClass("active");
    if (window.swiperInstances.realResult) {
      window.swiperInstances.realResult.slideNext();
    }
  });

  // Quick add button functionality
  $(".quick_add .sizes button").click(function () {
    $(".quick_add .sizes button").removeClass("active");
    $(this).addClass("active");
  });

  $(document).on("click", ".quick_add_btn:not(.add-tocart)", function () {
    $(".quick_add").removeClass("active");
    $(this).next(".quick_add").addClass("active");
  });

  $(document).click(function (e) {
    if (!$(e.target).closest(".quick_add, .quick_add_btn").length) {
      $(".quick_add").removeClass("active");
    }
  });

  // Quick add — direct add to cart (no-size products)
  $(document).on("click", ".add-tocart", function (e) {
    // Let the product-form custom element handle the main PDP button
    if ($(this).closest("product-form").length) return;
    e.preventDefault();
    e.stopPropagation();
    const btn = $(this);
    const variantId = btn.data("variant-id");
    if (!variantId) return;
    addToCart(variantId, btn);
  });

  // Quick add — size button add to cart
  $(document).on("click", ".quick-add-size", function (e) {
    e.preventDefault();
    e.stopPropagation();
    const btn = $(this);
    const variantId = btn.data("variant-id");
    if (!variantId) return;
    btn.closest(".quick_add").removeClass("active");
    addToCart(variantId, null);
  });

  function addToCart(variantId, btn) {
    if (btn) btn.prop("disabled", true).text("Adding...");

    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({ id: Number(variantId), quantity: 1 }),
    })
      .then((res) => {
        if (!res.ok) throw new Error("Add to cart failed");
        return res.json();
      })
      .then(async () => {
        if (btn) btn.prop("disabled", false).text("QUICK ADD");

        // Reconcile the complimentary wash-bag BEFORE refreshing the drawer, so the
        // re-fetched cart-drawer section reflects it. Quick-add bypasses the cart's
        // normal cartUpdate flow, so the complementary controller must be invoked
        // explicitly here or the wash-bag is never added/removed for this path.
        try {
          if (
            window.complementaryController &&
            window.complementaryController.addProduct
          ) {
            await window.complementaryController.addProduct(null, {
              silent: true,
            });
          }
        } catch (e) {
          /* non-blocking */
        }

        // Refresh cart drawer — same pattern used by product-list.liquid in this theme
        fetch("/?sections=cart-drawer")
          .then((res) => res.json())
          .then((sections) => {
            const html = sections["cart-drawer"];
            if (!html) return;

            const temp = document.createElement("div");
            temp.innerHTML = html;

            const newDrawer =
              temp.querySelector("cart-drawer") ||
              temp.querySelector(".cart-drawer");
            const currentDrawer =
              document.querySelector("cart-drawer") ||
              document.querySelector(".cart-drawer");

            if (newDrawer && currentDrawer) {
              currentDrawer.innerHTML = newDrawer.innerHTML;
            }

            if (typeof currentDrawer?.open === "function") {
              currentDrawer.open();
            } else if (currentDrawer) {
              currentDrawer.classList.add("active");
              document.body.classList.add("overflow-hidden");
            }
          });
      })
      .catch((err) => {
        console.error(err);
        if (btn) btn.prop("disabled", false).text("QUICK ADD");
      });
  }

  // Tab activation function
  function activateTab(data_tab, data_text = null) {
    $(
      ".tab_content_img img, .middle div, .lab_testing .count, .pagination-dots .dot",
    ).removeClass("active");
    $("#" + data_tab).addClass("active");
    $("#" + data_tab + "_1").addClass("active");
    $(".lab_testing .count[data-tab='" + data_tab + "']").addClass("active");
    $(".pagination-dots .dot[data-tab='" + data_tab + "']").addClass("active");
  }

  // // Tab button click
  // $(".tab_img_change .tab_btn").click(function () {

  //   let data_tab = $(this).attr("data-tab");
  //   let data_text = $(this).attr("data-text");
  //   alert(data_text)
  //   activateTab(data_tab, data_text);
  // });

  // Count number click
  $(".lab_testing .count").click(function () {
    let data_tab = $(this).attr("data-tab");
    activateTab(data_tab);
  });

  // Pagination dot click
  $(".pagination-dots .dot").click(function () {
    let data_tab = $(this).attr("data-tab");
    activateTab(data_tab);
  });

  // Default: activate first image in each section
  $(".tab_img_change").each(function () {
    $(this).find(".tab-image-wrapper").first().addClass("active");
  });

  // MERGED TAB SWITCH — shared with the post-variant-swap rebinding in
  // product-variant-metafields.js (the swap replaces the section elements,
  // killing the binding below, so that file rebinds and calls this).
  // The crossfade is held until the incoming tab's image is fetched AND
  // decoded: inactive wrappers sit at opacity:0/visibility:hidden, so their
  // loading="lazy" images may not have been fetched yet — activating one
  // mid-download is what flashed on the first click-through of the tabs.
  window.pdpTabSwitch = function ($section, $btn, tab, text) {
    // tab-with-image uses its own Swiper-based handler; skip to avoid class churn
    if ($section.hasClass("tab-with-image")) return;

    const section = $section[0];
    const $wrapper = $section.find(".scroll-" + tab);
    // Rapid clicks: only the latest requested tab may complete its switch.
    const token = (section._pdpTabToken = (section._pdpTabToken || 0) + 1);

    function doSwitch() {
      if (section._pdpTabToken !== token) return; // superseded by a newer click

      /* 🔴 Reset buttons + titles (image wrappers cross-fade below) */
      $section.find(".tab_btn, .title").removeClass("active");

      /* 🟢 Activate clicked button */
      $btn.addClass("active");

      /* 🟢 Activate text */
      if (text) {
        $section.find("#" + text).addClass("active");
      } else {
        $section.find(".title[data-text='" + tab + "']").addClass("active");
      }

      /* 🟢 Cross-fade the image without a flash. The old approach dropped
         .active from every wrapper at once, so the outgoing image faded out
         while the incoming faded in — at the midpoint both were semi-
         transparent and the container background bled through (the flash).
         Instead we hold the outgoing image FULLY OPAQUE one layer beneath the
         incoming (via .tab-leaving) while the incoming fades in on top, then
         drop it once the fade has completed. */
      const $activeWrapper = $wrapper;
      if (!$activeWrapper.hasClass("active")) {
        const $outgoing = $section
          .find(".tab-image-wrapper.active")
          .not($activeWrapper);
        // Clean up any half-finished previous swap first.
        $section
          .find(".tab-image-wrapper.tab-leaving")
          .removeClass("tab-leaving");
        clearTimeout(section._pdpTabLeaveTimer);

        $outgoing.removeClass("active").addClass("tab-leaving");
        $activeWrapper.addClass("active");

        section._pdpTabLeaveTimer = setTimeout(function () {
          $outgoing.removeClass("tab-leaving");
        }, 450);
      }

      const vid = $activeWrapper.find("video")[0];
      // Stop the deactivated tab's video streaming; load + play the new one.
      // Tab switches don't change geometry, so lazy-video's observer can't
      // see them — activate explicitly.
      $section.find("video").each(function () {
        if (this !== vid) this.pause();
      });
      if (vid) {
        if (window.LazyVideo) window.LazyVideo.activate(vid);
        else vid.play().catch(function () {});
      }
    }

    const img = $wrapper.find("img").not(".tab-image-badge")[0];
    if (img && img.decode && !(img.complete && img.dataset.pdpDecoded)) {
      // A hidden lazy image may never have started fetching — force it now.
      if (img.loading === "lazy") img.loading = "eager";
      let called = false;
      const go = function () {
        if (called) return;
        called = true;
        img.dataset.pdpDecoded = "1";
        doSwitch();
      };
      img.decode().then(go, go);
      // Never leave the click stuck on a stalled network — swap anyway.
      setTimeout(go, 1000);
    } else {
      doSwitch();
    }
  };

  // MERGED TAB CLICK HANDLER
  $(".tab_img_change").on("click", ".tab_btn", function () {
    const $section = $(this).closest(".tab_img_change");
    const tab = $(this).data("tab");
    const text = $(this).data("text"); // optional
    if (!tab) return;
    window.pdpTabSwitch($section, $(this), tab, text);
  });

  // ── Tab media warm-up ──────────────────────────────────────────────
  // Hidden tab layers never paint, so browsers (Safari in particular)
  // skip their loading="lazy" images entirely until the tab is clicked.
  // Once a tab section is within ~1.5 viewports — and only after the page
  // has fully loaded, so this never competes with the hero/LCP — flip
  // those images to eager and decode them, so every tab already has
  // pixels ready the first time it fades in.
  function warmTabMedia(section) {
    if (section.dataset.tabsWarmed) return;
    section.dataset.tabsWarmed = "1";
    section
      .querySelectorAll(".tab-image-wrapper img")
      .forEach(function (img) {
        if (img.loading === "lazy") img.loading = "eager";
        if (img.decode) {
          img
            .decode()
            .then(function () {
              img.dataset.pdpDecoded = "1";
            })
            .catch(function () {});
        }
      });
  }

  let tabWarmupPageLoaded = document.readyState === "complete";

  function initTabMediaWarmup() {
    if (!tabWarmupPageLoaded) return; // window load listener re-runs this
    const sections = document.querySelectorAll(
      ".tab_img_change:not([data-tabs-warmed])",
    );
    if (!sections.length) return;
    if (typeof IntersectionObserver === "undefined") {
      sections.forEach(warmTabMedia);
      return;
    }
    const io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          warmTabMedia(entry.target);
          io.unobserve(entry.target);
        });
      },
      { rootMargin: "150% 0px" },
    );
    sections.forEach(function (s) {
      io.observe(s);
    });
  }

  if (tabWarmupPageLoaded) {
    initTabMediaWarmup();
  } else {
    window.addEventListener(
      "load",
      function () {
        tabWarmupPageLoaded = true;
        initTabMediaWarmup();
      },
      { once: true },
    );
  }
  // Variant colour swap replaces the tab sections wholesale — warm the
  // fresh copies too (no-op until the page has finished loading).
  document.addEventListener("pdp:sectionsUpdated", initTabMediaWarmup);

  // ── Skin-care results min-height lock (desktop) ───────────────────
  // Tab switches swap the left column's text, so a shorter tab lets the
  // section collapse and everything below it jumps. Measure the content
  // column and pin the section to it via a CSS variable, applied at
  // min-width: 769px in section-main-product.css.
  const skinCareResultsDesktop = window.matchMedia("(min-width: 769px)");

  function setSkinCareResultsMinHeight() {
    const content = document.getElementById("skin-care-results-content");
    if (!content) return;
    const section = content.closest(".tab-change-pdp1");
    if (!section) return;
    if (!skinCareResultsDesktop.matches) {
      section.style.removeProperty("--skin-care-results-min-height");
      return;
    }
    const height = Math.ceil(content.getBoundingClientRect().height);
    if (height > 0) {
      section.style.setProperty(
        "--skin-care-results-min-height",
        height + "px",
      );
    }
  }

  setSkinCareResultsMinHeight();
  // Re-measure once fonts/images have settled the layout.
  window.addEventListener("load", setSkinCareResultsMinHeight, { once: true });

  let skinCareResultsResizeTimer;
  window.addEventListener("resize", function () {
    clearTimeout(skinCareResultsResizeTimer);
    skinCareResultsResizeTimer = setTimeout(setSkinCareResultsMinHeight, 200);
  });

  // Variant colour swap replaces the section wholesale, and the theme
  // editor's re-render wipes the inline variable — re-measure for both.
  document.addEventListener("pdp:sectionsUpdated", setSkinCareResultsMinHeight);
  document.addEventListener(
    "shopify:section:load",
    setSkinCareResultsMinHeight,
  );

  // Clinical additional image click - toggle to inactive tab
  $(".tab_img_change").on("click", ".clinical_additional_image", function () {
    const $section = $(this).closest(".tab_img_change");
    const $inactiveBtn = $section.find(".tab_btn:not(.active)");
    const swiperEl = $(this).closest(".swiper.swiper-initialized");
    if (swiperEl && swiperEl.swiper) {
      swiperEl.swiper.slideNext();
    } else if ($inactiveBtn.length) {
      $inactiveBtn.click();
    }
  });

  // Result card lab insight crossfade toggle
  function bindHandlers() {
    $(".result-card__link").off("click");

    $(".result-card__link").on("click", function (e) {
      e.preventDefault();
      const $card = $(this).closest(".result-card");
      const $icon = $(this).find(".toggle-icon");
      const isOpen = $card.hasClass("is-open");

      $(".result-card.is-open")
        .not($card)
        .each(function () {
          $(this).removeClass("is-open");
          $(this).find(".toggle-icon").text("+");
          $(this).find(".result-card__link").attr("aria-expanded", "false");
        });

      $card.toggleClass("is-open", !isOpen);
      $icon.text(!isOpen ? "−" : "+");
      $(this).attr("aria-expanded", String(!isOpen));
    });
  }

  bindHandlers();

  // Grid view toggle
  $(".two-list").on("click", function () {
    $(".grid-item-shop").removeClass("col-md-4").addClass("col-6");
    $(".product-list").addClass("two-view").removeClass("three-view");
    $(this).addClass("active");
    $(".three-list").removeClass("active");
  });

  $(".three-list").on("click", function () {
    $(".grid-item-shop").removeClass("col-6").addClass("col-md-4");
    $(".product-list").addClass("three-view").removeClass("two-view");
    $(this).addClass("active");
    $(".two-list").removeClass("active");
  });

  // Hydrate section toggle
  $(".hydrate-section__item").on("click", function () {
    let data_target_h = $(this).attr("data-target");

    $(".hydrate-section__item").removeClass("hydrate-section__item--active");
    $(this).addClass("hydrate-section__item--active");
    $(".hydrate-img").removeClass("hydrate-img--active");
    $('.hydrate-img[data-img="' + data_target_h + '"]').addClass(
      "hydrate-img--active",
    );
  });

  // Resize handler for all swipers
  let resizeTimer;
  let lastWidth = window.innerWidth;
  let isResizing = false;

  function handleResize() {
    const currentWidth = window.innerWidth;

    // The only real layout break for these sliders is 768 (mobile <-> desktop);
    // slidesPerView/loop config is identical across all widths on the same side
    // of it. Crossing 992/1200 or any large desktop drag changes nothing, so the
    // old full destroy+rebuild there only produced a visible flash.
    const crossedMobileBoundary =
      (lastWidth >= 768 && currentWidth < 768) ||
      (lastWidth < 768 && currentWidth >= 768);

    if (crossedMobileBoundary) {
      console.log(
        "Mobile/desktop boundary crossed",
        lastWidth,
        "->",
        currentWidth,
      );
      initAllSwipers();
    } else {
      // Same side of 768: only re-measure non-loop sliders. Calling update() on a
      // loop slider re-clones its slides and can reset the track, which reads as a
      // flash (worst on the .glow-wear-peek slider). Swiper's own resize observer
      // keeps loop sliders sized without us forcing it.
      Object.keys(window.swiperInstances).forEach((key) => {
        const swiper = window.swiperInstances[key];
        if (!swiper || typeof swiper.update !== "function") return;
        if (swiper.params && swiper.params.loop) return;
        if (key === "productGlow") {
          swiper.params.breakpoints = generateBreakpointValues();
        }
        swiper.update();
      });
    }

    lastWidth = currentWidth;
    isResizing = false;
  }

  window.addEventListener("resize", () => {
    if (!isResizing) {
      isResizing = true;
    }
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(handleResize, 200);
  });

  // Rebind handlers on resize
  $(window).on("resize", function () {
    bindHandlers();
  });

  window.addEventListener("orientationchange", () => {
    setTimeout(() => {
      console.log("Orientation change detected");
      initAllSwipers();
    }, 300);
  });

  // Fix for Safari iOS privacy notice causing layout shift after init
  let lastViewportHeight = window.visualViewport
    ? window.visualViewport.height
    : window.innerHeight;
  function handleViewportHeightChange() {
    const currentHeight = window.visualViewport
      ? window.visualViewport.height
      : window.innerHeight;
    if (Math.abs(currentHeight - lastViewportHeight) > 50) {
      lastViewportHeight = currentHeight;
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        Object.keys(window.swiperInstances).forEach((key) => {
          const swiper = window.swiperInstances[key];
          if (!swiper || typeof swiper.update !== "function") return;
          // Skip loop sliders: update() re-clones their slides and flickers them.
          if (swiper.params && swiper.params.loop) return;
          swiper.update();
        });
      }, 150);
    }
  }

  if (window.visualViewport) {
    window.visualViewport.addEventListener(
      "resize",
      handleViewportHeightChange,
    );
  } else {
    window.addEventListener("resize", handleViewportHeightChange);
  }

  document.addEventListener("visibilitychange", () => {
    if (!document.hidden) {
      setTimeout(() => {
        const currentWidth = window.innerWidth;
        if (Math.abs(currentWidth - lastWidth) > 100) {
          console.log("Window visibility changed with size difference");
          initAllSwipers();
          lastWidth = currentWidth;
        }
      }, 100);
    }
  });

  // Reinitialize swipers when page is restored from bfcache (back/forward button)
  window.addEventListener("pageshow", function (event) {
    if (event.persisted) {
      initAllSwipers();
    }
  });

  // Theme editor only: the customizer swaps a section's HTML in place via the
  // Section Rendering API without reloading the page. Swipers are initialized
  // once on load, so the freshly injected slider markup is left uninitialized
  // and looks broken until a manual refresh. Re-init when an edited section
  // actually contains a slider. This event never fires on the live storefront.
  document.addEventListener("shopify:section:load", function (event) {
    var section = /** @type {Element} */ (event.target);
    if (section && section.querySelector(".swiper")) {
      initAllSwipers();
    }
  });
});

$(document).on("change", ".file-input", function () {
  let fileName = $(this).val().split("\\").pop();
  $(".file-title").text(fileName);
});

// document.addEventListener('DOMContentLoaded', function () {
//   /* ---------------- VARIANT DATA ---------------- */
//   const variants = JSON.parse(
//     document.getElementById('variant-data')?.textContent || '[]'
//   );

//   let selectedSize = null;
//   let selectedColor = null;
//   const addToCartBtn = document.querySelector('.add-tocart');

//   // Set first available color as default
//   const firstColorSwatch = document.querySelector('.color-swatch');
//   if (firstColorSwatch) {
//     firstColorSwatch.classList.add('active');
//     selectedColor = firstColorSwatch.dataset.color;
//     const colorName = document.getElementById('selectedColor');
//     if (colorName) colorName.textContent = selectedColor;
//   }

//   function updateVariantId() {
//     if (!selectedSize || !selectedColor) return;

//     const matchedVariant = variants.find(v =>
//       v.options.includes(selectedSize) && v.options.includes(selectedColor)
//     );

//     if (matchedVariant && addToCartBtn) {
//       addToCartBtn.dataset.variantId = matchedVariant.id;
//       return true;
//     }
//     return false;
//   }

//   function updateSizeAvailability() {
//     if (!selectedColor) return;

//     document.querySelectorAll('.size-btn').forEach(btn => {
//       const size = btn.dataset.size;
//       const variantExists = variants.find(v =>
//         v.options.includes(size) &&
//         v.options.includes(selectedColor) &&
//         v.available
//       );

//       if (!variantExists || !variantExists.available) {
//         btn.classList.add('disabled');
//         btn.disabled = true;
//       } else {
//         btn.classList.remove('disabled');
//         btn.disabled = false;
//       }
//     });
//   }

//   /* ---------------- SIZE SELECT ---------------- */
//   document.querySelectorAll('.size-btn').forEach(btn => {
//     btn.addEventListener('click', function () {
//       if (this.disabled || this.classList.contains('disabled')) return;

//       document.querySelectorAll('.size-btn').forEach(b => b.classList.remove('active'));
//       this.classList.add('active');
//       selectedSize = this.dataset.size;
//       updateVariantId();
//     });
//   });

//   /* ---------------- COLOR SELECT ---------------- */
//   document.querySelectorAll('.color-swatch').forEach(swatch => {
//     swatch.addEventListener('click', function () {
//       document.querySelectorAll('.color-swatch').forEach(s => s.classList.remove('active'));
//       this.classList.add('active');
//       selectedColor = this.dataset.color;

//       // Update color name display
//       const colorName = document.getElementById('selectedColor');
//       if (colorName) colorName.textContent = selectedColor;

//       // Reset size selection and update availability
//       selectedSize = null;
//       document.querySelectorAll('.size-btn').forEach(b => b.classList.remove('active'));
//       updateSizeAvailability();
//       updateVariantId();
//     });
//   });

//   // Initial size availability check
//   updateSizeAvailability();

//   /* ---------------- ADD TO CART ---------------- */
//   document.addEventListener('click', function (e) {
//     const button = e.target.closest('.add-tocart');
//     if (!button) return;
//     e.preventDefault();

//     // Validate selections
//     if (!selectedColor) {
//       alert('Please select a color');
//       return;
//     }

//     if (!selectedSize) {
//       alert('Please select a size');
//       return;
//     }

//     const variantId = button.dataset.variantId;
//     if (!variantId) {
//       alert('Selected variant is not available');
//       return;
//     }

//     const btnText = button.querySelector('.btn-text');
//     const btnLoading = button.querySelector('.btn-loading');

//     // Loader ON
//     button.disabled = true;
//     if (btnText) btnText.style.display = 'none';
//     if (btnLoading) btnLoading.style.display = 'inline-block';

//     fetch('/cart/add.js', {
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/json',
//         Accept: 'application/json',
//       },
//       body: JSON.stringify({
//         id: Number(variantId),
//         quantity: 1,
//       }),
//     })
//       .then(res => {
//         if (!res.ok) throw new Error('Add to cart failed');
//         return res.json();
//       })
//       .then(() => {
//         refreshCart(button, btnText, btnLoading);
//       })
//       .catch(err => {
//         console.error(err);
//         alert('Failed to add item to cart');
//         resetButton(button, btnText, btnLoading);
//       });
//   });

//   /* ---------------- UPSELL ADD TO CART ---------------- */
//   document.addEventListener('click', function (e) {
//     const btn = e.target.closest('.upsell-add-to-cart');
//     if (!btn) return;

//     const variantId = btn.dataset.variantId;
//     if (!variantId) return;

//     btn.disabled = true;
//     const originalText = btn.textContent;
//     btn.textContent = 'Adding...';

//     fetch('/cart/add.js', {
//       method: 'POST',
//       headers: { 'Content-Type': 'application/json' },
//       body: JSON.stringify({ id: Number(variantId), quantity: 1 }),
//     })
//       .then(res => res.json())
//       .then(() => refreshCart())
//       .catch(err => console.error(err))
//       .finally(() => {
//         btn.disabled = false;
//         btn.textContent = originalText;
//       });
//   });
// });

// /* ================= CART REFRESH ================= */
// function refreshCart(button, btnText, btnLoading) {
//   fetch('/cart.js')
//     .then(res => res.json())
//     .then(cart => {
//       document.querySelectorAll('[data-cart-count], .cart-count').forEach(el => {
//         el.textContent = cart.item_count;
//         el.setAttribute('data-cart-count', cart.item_count);
//       });
//       return fetch('/?section_id=cart-drawer');
//     })
//     .then(res => res.text())
//     .then(html => {
//       updateDrawer(html);
//       openDrawer();
//       if (button) resetButton(button, btnText, btnLoading);
//     })
//     .catch(() => {
//       openDrawer();
//       if (button) resetButton(button, btnText, btnLoading);
//     });
// }

// /* ================= DRAWER ================= */
// function updateDrawer(html) {
//   const temp = document.createElement('div');
//   temp.innerHTML = html;
//   const newDrawer = temp.querySelector('.cart-drawer');
//   const currentDrawer = document.querySelector('.cart-drawer');

//   if (!newDrawer || !currentDrawer) return;

//   currentDrawer.innerHTML = newDrawer.innerHTML;

//   // Re-init sliders after DOM update
//   setTimeout(() => {
//     initCartProductSwiper();
//     if (window.initCartUpsellSwiper) {
//       window.initCartUpsellSwiper();
//     }
//     reattachQuantityListeners();
//   }, 100);
// }

// function openDrawer() {
//   const drawer = document.querySelector('cart-drawer') || document.querySelector('.cart-drawer');
//   if (!drawer) return;

//   if (typeof drawer.open === 'function') {
//     drawer.open();
//   } else {
//     drawer.classList.add('active', 'open');
//     document.body.classList.add('overflow-hidden');
//   }
// }

// function resetButton(button, btnText, btnLoading) {
//   if (btnText) btnText.style.display = 'inline';
//   if (btnLoading) btnLoading.style.display = 'none';
//   button.disabled = false;
// }

// function initCartProductSwiper() {
//   const swiperEl = document.querySelector('.cart-product-swiper');
//   if (!swiperEl) return;

//   // Destroy existing instance if any
//   if (swiperEl.swiper) {
//     swiperEl.swiper.destroy(true, true);
//   }

//   new Swiper(swiperEl, {
//     slidesPerView: 1,
//     spaceBetween: 12,
//     navigation: {
//       nextEl: '.cart-product-swiper .swiper-button-next',
//       prevEl: '.cart-product-swiper .swiper-button-prev',
//     },
//     observer: true,
//     observeParents: true,
//     watchOverflow: true,
//   });
// }

// /* ================= QUANTITY CHANGE LISTENER ================= */
// function reattachQuantityListeners() {
//   const quantityButtons = document.querySelectorAll('.cart-item__quantity-btn, .quantity-btn, [data-quantity-change]');

//   quantityButtons.forEach(btn => {
//     btn.addEventListener('click', function() {
//       setTimeout(() => {
//         // Reinit sliders after quantity change
//         initCartProductSwiper();
//         if (window.initCartUpsellSwiper) {
//           window.initCartUpsellSwiper();
//         }
//       }, 300);
//     });
//   });
// }

// // Initial attachment
// document.addEventListener('DOMContentLoaded', function() {
//   reattachQuantityListeners();
// });

// load more reviews

(function () {
  var initialCount = window.innerWidth <= 749 ? 2 : 3;

  function getItems() {
    return Array.from(
      document.querySelectorAll(".review-list .review-section__item"),
    );
  }

  function collapse(instant) {
    getItems().forEach(function (item, index) {
      if (index >= initialCount) {
        if (instant) {
          item.style.transition = "none";
          item.classList.add("is-collapsed");
          requestAnimationFrame(function () {
            requestAnimationFrame(function () {
              item.style.transition = "";
            });
          });
        } else {
          item.classList.add("is-collapsed");
        }
      }
    });
  }

  function expand() {
    getItems().forEach(function (item, index) {
      if (index >= initialCount) {
        item.style.display = ""; // clear inline display:none set by Liquid
        item.offsetHeight; // force reflow so CSS transition fires from collapsed state
        item.classList.remove("is-collapsed");
      }
    });
  }

  // Initial collapse on page load (instant, no animation)
  document.addEventListener("DOMContentLoaded", function () {
    collapse(true);
  });

  // Re-collapse after variant metafield sections are swapped
  document.addEventListener("pdp:sectionsUpdated", function () {
    collapse(true);
  });

  // Event delegation — survives innerHTML replacement
  document.addEventListener("click", function (e) {
    var btn = e.target.closest("#loadMoreReviews");
    if (!btn) return;

    var isExpanded = btn.dataset.expanded === "true";
    if (!isExpanded) {
      expand();
      btn.textContent = "SHOW LESS";
      btn.dataset.expanded = "true";
    } else {
      collapse(false);
      btn.textContent = "SHOW MORE";
      btn.dataset.expanded = "false";

      // Scroll back to the TOP of the reviews section so the customer lands on the
      // rating summary (4.9 / stars / AVERAGE RATING) in full view — not mid-list.
      // Leave a 60px gap so the fixed header doesn't cover the top of the section.
      var reviewSection = document.querySelector(".review-section");
      if (reviewSection) {
        const additonalTopScroll = window.innerWidth < 769 ? 60 : 120;
        var top =
          reviewSection.getBoundingClientRect().top +
          window.scrollY -
          additonalTopScroll;
        window.scrollTo({ top: top, behavior: "smooth" });
      }
    }
  });

  // PDP accordions intentionally do NOT auto-collapse on scroll (this observer only
  // ever targeted [data-pdp-section="product-accordions"], which exists solely on the
  // main-product section — accordions on every other page are unaffected).
  // Collapsing the section once it sits above the viewport shrank above-the-fold content
  // and required a compensating window.scrollBy. Because IntersectionObserver callbacks
  // aren't frame-synced with the user's scroll, that correction couldn't be made
  // invisible — it flashed on the first scroll past the section. Panels now stay in
  // whatever state the customer left them: no layout mutation above the viewport, so no
  // shift and no flicker.
})();
